import { registerVueComponentAndAngularBindings, declareComponents} from '/vodalys/vvuejs'

import PlanCustom from './PlanCustom.vue'
registerVueComponentAndAngularBindings('plan:custom', 'planCustom', PlanCustom)

import PlanCustomEdit from './PlanCustomEdit.vue'
registerVueComponentAndAngularBindings('plan:custom:edit', 'planCustomEdit', PlanCustomEdit)

import components from './**/*.vue'
declareComponents('components', components)
